import { render, staticRenderFns } from "./Promocodes.vue?vue&type=template&id=58dd332b&scoped=true&"
import script from "./Promocodes.vue?vue&type=script&lang=js&"
export * from "./Promocodes.vue?vue&type=script&lang=js&"
import style0 from "./Promocodes.vue?vue&type=style&index=0&id=58dd332b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58dd332b",
  null
  
)

export default component.exports